var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28906 7.74594V4.125C3.28906 2.49375 4.61094 1.17188 6.24219 1.17188H55.9484C57.5797 1.17188 58.9016 2.49375 58.9016 4.125V12.35",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9016 37.4935V66.8426L46.9141 78.8285H6.24219C4.61094 78.8285 3.28906 77.5066 3.28906 75.8754V13.2363",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9016 66.8418L46.9141 78.8277V69.7949C46.9141 68.1637 48.2359 66.8418 49.8672 66.8418H58.9016Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1681 26.5279L16.0659 31.6301C14.8681 32.8279 12.9273 32.8279 11.7295 31.6301C10.5326 30.4332 10.5328 28.4924 11.7304 27.2946L16.8326 22.1924C18.0304 20.9946 19.9712 20.9946 21.1681 22.1915C21.767 22.7904 22.0669 23.5751 22.0669 24.3596C22.067 25.1443 21.767 25.929 21.1681 26.5279Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1684 26.5279L18.722 28.9743L14.3867 24.6388L16.8331 22.1924C18.0309 20.9946 19.9717 20.9946 21.1686 22.1915C21.7675 22.7904 22.0673 23.5751 22.0673 24.3596C22.0673 25.1443 21.7673 25.929 21.1684 26.5279Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4481 51.5701C19.2197 51.5701 21.4666 49.3232 21.4666 46.5516C21.4666 43.78 19.2197 41.5332 16.4481 41.5332C13.6765 41.5332 11.4297 43.78 11.4297 46.5516C11.4297 49.3232 13.6765 51.5701 16.4481 51.5701Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9956 43.0029L12.8984 50.1001",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.408 67.2577C20.408 69.4447 18.635 71.2175 16.4481 71.2175C14.2613 71.2175 12.4883 69.4446 12.4883 67.2577C12.4883 65.0707 16.4481 59.3955 16.4481 59.3955C16.4481 59.3955 20.408 65.0707 20.408 67.2577Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 23.0332H48.1059",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 27.5322H36.7833",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 41.5332H48.1059",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 46.0322H36.7833",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 60.0332H48.1059",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 64.5322H36.7833",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2344 10.4863H39.9497",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5699 31.9938H50.8005C49.1355 31.9938 48.11 30.1739 48.9725 28.7497L60.8572 9.12566C61.689 7.75238 63.6813 7.75238 64.513 9.12566L76.3977 28.7497C77.2602 30.1741 76.2349 31.9938 74.5699 31.9938Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6836 16.2012V22.4851",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6836,
    cy: 26.8564,
    r: 1.17188,
    fill: "#011337"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSus2);
export default __webpack_public_path__ + "static/media/sus2.cd160cd1cd9b081760590a8666d096f3.svg";
export { ForwardRef as ReactComponent };